import { lazy, Suspense, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Index from "./pages/Index";

const NotFound = lazy(() => import("./pages/NotFound"));
const TermsOfService = lazy(() => import("./pages/TermsOfService"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const FAQ = lazy(() => import("./pages/FAQ"));

const LazyProviders = lazy(() =>
  Promise.all([
    import("@/components/ui/toaster"),
    import("@/components/ui/sonner"),
    import("@/components/ui/tooltip"),
    import("@tanstack/react-query"),
  ]).then(([{ Toaster }, { Toaster: Sonner }, { TooltipProvider }, { QueryClient, QueryClientProvider }]) => {
    const queryClient = new QueryClient();
    return {
      default: ({ children }: { children: React.ReactNode }) => (
        <QueryClientProvider client={queryClient}>
          <TooltipProvider>
            <Toaster />
            <Sonner />
            {children}
          </TooltipProvider>
        </QueryClientProvider>
      ),
    };
  })
);

const DeferredProviders = ({ children }: { children: React.ReactNode }) => {
  const [ready, setReady] = useState(false);
  useEffect(() => { setReady(true); }, []);
  if (!ready) return <>{children}</>;
  return (
    <Suspense fallback={<>{children}</>}>
      <LazyProviders>{children}</LazyProviders>
    </Suspense>
  );
};

const App = () => (
  <DeferredProviders>
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/faq" element={<FAQ />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </DeferredProviders>
);

export default App;
